import script from "./UserStores.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserStores.vue?vue&type=script&setup=true&lang=ts"

import "./UserStores.vue?vue&type=style&index=0&id=909876ba&scoped=true&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-909876ba"]])

export default __exports__